import * as React from 'react'
import Loader from 'react-loader-spinner';

type Props = {
  height?: number,
  width?: number,
  centered?: boolean
}

const LoaderSpinner = ({centered=true, ...rest }: Props) => {
  let classes = '';
  if (centered) {
    classes += ' flex justify-center'
  }
  return (
    <div className={classes}>
      <Loader {...rest} color="#27A3A4" type="ThreeDots"></Loader>
    </div>
  );
};

export default LoaderSpinner;